import React from 'react';
import { Anchor as AnchorIcon } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';
import { renderSettingText } from '../lib/textTemplate';

/* Canlı Betrun'un modülü BinoGaming'de olmayan iki sayfası (Çapa, Sponsorluk).
 * Canlıda ikisi de boş durumda (etkinlik kapalı, yayında sponsorluk yok);
 * eski bağlantı ve Telegram gönderileriyle gelen oyuncu aynı sayfayı görür.
 * Metin ve düzen canlı Betrun'un Anchor.jsx / Sponsorships.jsx boş
 * durumundan birebirdir. Yalnız Betrun şemasında çizilir (App.js).
 */
export default function BetrunLegacyPage({ page }) {
  const settings = useSettings();

  if (page === 'capa') {
    return (
      <main className="max-w-3xl mx-auto px-4 py-16 text-center">
        <AnchorIcon className="w-10 h-10 mx-auto text-gray-500 mb-4" />
        <h1 className="text-xl font-bold text-white mb-2">Çapayı At</h1>
        <p className="text-sm text-gray-400">
          Çapa etkinliği şu anda kapalı. Yakında tekrar açılacak.
        </p>
      </main>
    );
  }

  const brand = renderSettingText('{{site_name}}', settings);
  return (
    <main className="sponsorship-page">
      <header className="sponsorship-page-head">
        <h1>Sponsorluklarımız</h1>
        <p>
          {brand
            ? `${brand} olarak destek verdiğimiz kulüpler, ligler ve organizasyonlar.`
            : 'Destek verdiğimiz kulüpler, ligler ve organizasyonlar.'}
        </p>
      </header>
      <p className="text-center text-sm text-slate-400 py-8">
        Şu anda yayınlanan bir sponsorluk bulunmuyor.
      </p>
    </main>
  );
}
